<template>
  <div class="order">
    <div class="order_nav">
      <navbar
        title="用户售后订单"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        :righticonshow="true"
        :righticon="righticon"
        @rightclick="toSearch"
        @goback="goBack(false)"
      />
    </div>
    <div class="all">
        <div class="all-tab">
          <!-- <div class="item-tab" :class="{'active-acl':active==n}" v-for="(m,n) in itemList" @click="showActive(n)" :key="n">{{m}}</div> -->
          <van-tabs v-model="active" style="width:100%" @click="showActive">
            <van-tab :title="m" v-for="(m,n) in itemList" :key="n"></van-tab>
          </van-tabs>
        </div>
        <div class="all-list">
          <van-pull-refresh
            v-model="isLoading"
            @refresh="onRefresh"
            v-if="list.length != 0"
          >
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <van-cell class="lists" v-for="(item, index) in list" :key="index">
                <div>
                  <van-row @click="detail(item)">
                    <van-col span="24" class="title">
                      <img :src="item.head_pic" />
                      {{ item.user_name }}
                      <span>{{active == 0?'待收货':'已收货'}}</span>
                    </van-col>
                    <van-col span="24" class="goods_info">
                      <div class="info_box" v-if="item.goods">
                        <div class="left">
                          <img :src="item.goods.sku_image" @error="nofind()" />
                          <p class="goods_name">{{ item.goods.goods_name }}</p>
                          <!-- <p class="spec">{{ item.goods.specification_name }}</p> -->
                          <p class="spec">
                            <span v-if="item.goods.specification_name">规格：</span
                            >{{ item.goods.specification_name }}
                          </p>
                          <!-- <p>运费￥{{ item.goods.goods_postage }}</p> -->
                        </div>
                        <div class="right">
                          <p>￥{{ item.goods.cost_price }}</p>
                          <p>X{{ item.goods.quantity }}</p>
                        </div>
                        <p class="goods_postage">
                          运费￥{{ item.goods.goods_postage }}
                        </p>
                      </div>
                      <p class="money">
                        合计金额：<span>￥{{ item.amount }}</span>
                      </p>
                    </van-col>
                  </van-row>
                  <van-row>
                    <van-col span="24" class="btns" >
                      <btn
                        :btntext="'联系买家'"
                        :btnwidth="'8rem'"
                        :height="'3.2rem'"
                        :bgcolor="'#fff'"
                        :borderradius="'1.6rem'"
                        :btncolor="'#333'"
                        :btnborder="'solid 0.1rem #ccc'"
                        :fontsize="'1.2rem'"
                        :btnmargin="'1.1rem 0 0 1.2rem'"
                        @btnClick="contact(item)"
                      />
                      <btn
                        :btntext="'确认收货'"
                        :btnwidth="'8rem'"
                        :height="'3.2rem'"
                        :bgcolor="'linear-gradient(to right, #fc740c, #f41a3c)'"
                        :borderradius="'1.6rem'"
                        :btncolor="'#fff'"
                        :fontsize="'1.2rem'"
                        :btnmargin="'1.1rem 0 0 1.2rem'"
                        @btnClick="receive(item)"
                        v-if="isSupplier == 1 && active == 0"
                      />
                      <btn
                        :btntext="'查看详情'"
                        :btnwidth="'8rem'"
                        :height="'3.2rem'"
                        :bgcolor="'linear-gradient(to right, #fc740c, #f41a3c)'"
                        :borderradius="'1.6rem'"
                        :btncolor="'#fff'"
                        :fontsize="'1.2rem'"
                        :btnmargin="'1.1rem 0 0 1.2rem'"
                        v-if="item.status != 30"
                        @btnClick="detail(item)"
                      />
                    </van-col>
                  </van-row>
                </div>
              </van-cell>
            </van-list>
          </van-pull-refresh>
          <van-row class="empty" v-if="list.length == 0 && !hasList">
            <van-col class="emptyMsg" span="24">
              <img src="../../../assets/purchaseSupplier/common/no_info.png" />
              <p class="tip">无内容</p>
            </van-col>
          </van-row>
          <div class="loading" v-if="list.length <= 0 && hasList">
            <img src="../../../assets/accountAgent/common/loading.gif" />
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
import defaultImg from "@/assets/common/compare.png";
import avatarDefault from "@/assets/common/avatar.png";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      righticon: require("@/assets/purchaseSupplier/common/search.png"),
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      hasList: true,
      // storeId: "",
      isSupplier: "",
      itemList:['待收货','已收货'],
      active:0
    };
  },
   mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );

    window.onresize = () => {
      document.documentElement.style.setProperty(
        "font-size",
        (document.body.clientWidth / 375) * 10 + "px"
      );
    };
  },
  created() {
    // this.storeId = this.$route.query.store_id;
    this.isSupplier = this.$route.query.is_supplier;
    if (localStorage.getItem("orderTab")) {
      this.active = Number(localStorage.getItem("orderTab"));
    }
    this.getInfo();
  },
  methods: {
    showActive(name,title){
      localStorage.setItem("orderTab", Number(name));
      this.active = name;
      this.page = 1;
      this.list = [];
      this.getInfo();
    },
    goBack() {
      localStorage.removeItem("orderTab");
      this.$router.go(-1);
    },
    toSearch() {
      this.$router.push("/purchaseSupplier/searchAfterOrder");
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
    },
    getInfo() {
      this.$api
        .post("/onorder/member/supplier/after/sale/list", {
          page: this.page,
          after_status_list: this.active == 0?[30]:[60,70,80],
          search: this.gooodsName,
          supplier_member_id: this.$route.query.member_id,
          type: 1
        })
        .then((res) => {
          this.allList = res.total;
          if (res.total <= 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              res.list[i].head_pic = res.list[i].head_pic || avatarDefault;
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    detail(item) {
      this.$router.push({
        path: "/purchaseSupplier/afterDetail",
        query: {
          id: item.id,
          // store_id: this.storeId,
          is_supplier: this.isSupplier,
          supplier_member_id: item.supplier_member_id,
        },
      });
    },
    contact(item) {
      let parm = {
        id: item.member_id,
        name: item.user_name,
        store_id: item.shop_id,
        supplier_member_id: item.supplier_member_id,
      };
      this.params(JSON.stringify(parm), JSON.stringify(parm), "contact");
    },
    receive(item) {
      this.$api
        .post("onorder/member/after/sale/supplier/confirm/receipt", {
          id: item.id,
        })
        .then((res) => {
          this.$router.push({
            path: "/purchaseSupplier/result",
            query: {
              type: 1,
            },
          });
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    nofind() {
      var img = event.srcElement;
      img.src = defaultImg;
      img.onerror = null; //防止闪图
    },
  },
};
</script>
<style lang="less" scoped>
.order {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .order_nav {
    // position: fixed;
    // top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .all {
    // padding-top: 8.8rem;
    flex: 1;
    box-sizing: border-box;
    // height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .all-tab{
      height: 4.4rem;
      width: 100%;
      display: flex;
      align-items: center;
      background: #fff;
      .item-tab{
        flex: 1;
        font-size: 1.4rem;
        color: #999999;
        text-align: center;
        height: 100%;
        line-height: 4.4rem
      }
      .active-acl{
        color: #333;
        position: relative;
      }
      /deep/ .van-tab{
        color: #999;
        font-size: 1.4rem;
      }
      /deep/ .van-tab--active{
        color: #333;
        font-weight: bold;
      }
      /deep/ .van-tabs__line{
        width: 9.8rem;
        height: 0.3rem;
        background: linear-gradient(90deg, #FC740C 0%, #F41A3C 100%);
      }
    }
    .all-list{
      flex: 1;
      overflow: hidden;
    }
    .van-pull-refresh {
      height: 100%;
      padding: 1.2rem 1.6rem 0;
      box-sizing: border-box;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;

      .lists {
        min-height: 22.3rem;
        border-radius: 0.8rem;
        background: #fff;
        margin-bottom: 1.2rem;
        padding: 0;

        .title {
          color: #333;
          font-size: 1.2rem;
          text-align: left;
          height: 4.5rem;
          line-height: 4.5rem;
          padding: 0 1.6rem 0 1.2rem;
          box-sizing: border-box;
          border-bottom: solid 0.05rem #eee;

          img {
            width: 2rem;
            margin-right: 0.8rem;
            float: left;
            margin-top: 1.2rem;
          }

          span {
            color: #ff4747;
            font-size: 1.2rem;
            float: right;
          }
        }

        .goods_info {
          min-height: 12.1rem;
          font-size: 1.4rem;
          color: #333;
          padding: 1.1rem 1.6rem 1.2rem 1.2rem;
          box-sizing: border-box;
          border-bottom: solid 0.05rem #eee;

          .info_box {
            position: relative;

            .left {
              min-height: 70px;
              padding: 0 6.5rem 0 8rem;

              img {
                width: 7rem;
                height: 7rem;
                // float: left;
                position: absolute;
                top: 0;
                left: 0;
              }

              p {
                line-height: 2rem;
              }

              .goods_name {
                height: 2rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .spec {
                color: #999;
                margin: 0.4rem 0 0.6rem;
              }
            }

            .right {
              float: right;
              position: absolute;
              right: 0;
              top: 0;
              min-width: 6.5rem;
              text-align: right;

              p {
                margin-bottom: 0.4rem;
              }
            }

            .goods_postage {
              line-height: 2rem;
              text-align: right;
              font-size: 1.4rem;
              color: #999;
            }
          }

          .money {
            line-height: 2rem;
            text-align: right;
            margin-top: 0.4rem;

            span {
              color: #ff4747;
            }
          }
        }

        .btns {
          text-align: right;
          padding: 0 1.5rem 1.2rem;
        }
      }
    }

    .empty {
      padding-top: 10rem;

      .emptyMsg {
        text-align: center;

        img {
          width: 16rem;
          display: inline-block;
        }

        .tip {
          color: #cccccc;
          font-size: 1.4rem;
          margin-top: 1.7rem;
          height: 2rem;
          line-height: 2rem;
        }
      }
    }

    .loading {
      width: 100%;
      /*padding-top: 100px;*/
      text-align: center;

      img {
        width: 35%;
        margin-top: 50%;
      }
    }
  }
}
</style>




